import {
  Box,
  Typography,
  Button,
  Grid,
  Container,
  Divider,
  Tab,
  Checkbox,
  DialogContent,
  DialogActions,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import React, { forwardRef, useEffect, useState } from 'react'
import Carousel from 'react-material-ui-carousel'
import WTypography from '../../../../Components/whiteTypography'
import { makeGetRequest, makePostRequest, makeDeleteRequest } from 'utils/api'
import urls from 'utils/urls'
import { useParams, useNavigate } from 'react-router-dom'
import { UTILISATION } from 'utils/constants'
import Avatar from '@mui/material/Avatar'

import FileUploadIcon from '@mui/icons-material/FileUpload'
import CloseIcon from '@mui/icons-material/Close'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'

import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

import Link from '@mui/material/Link'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import AttachmentIcon from '@mui/icons-material/Attachment'
import CreateDocumentsForm from '../../../../Components/CreateDocumentsForm'
import Slide from '@mui/material/Slide'

import { ImmobilierImgUploadForm } from './ImmobilierImgUploadForm'

import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { Fragment } from 'react'
import EditIcon from '@mui/icons-material/Edit'
import CalendarView from 'Components/CalendarView'
import CreateEventForm from './CreateEventForm'
import EventViewForm from './EventViewForm'
import ListTop from './ListTop'
import ListBottom from './ListBottom'
import CustomButton from 'Components/CustomButton/CustomButton'
import styled from '@emotion/styled'
import { useForm } from 'react-hook-form'
import ComboBox from 'Components/ComboBox'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'

var itemss = [
  {
    id: null,
    name: 'Random Name #1',
    description: 'Probably the most random thing you have ever seen!',
    picture:
      'https://images.pexels.com/photos/186077/pexels-photo-186077.jpeg?cs=srgb&dl=pexels-binyamin-mellish-186077.jpg&fm=jpg',
    // picture: '',
  },
]

const useStyles = styled((theme) => ({
  contactBox: {
    display: 'flex',
    // justifyContent: 'center',
    padding: '10px 0px',
    alignItems: 'center',
    marginLeft: '40px',
  },
}))

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const DocumentDetails = () => {
  const siteUser = useSelector((store) => store.user)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  let navigate = useNavigate()
  const [openAContactForm, setOpenAContactForm] = useState(false)
  const [selected, setSelected] = React.useState([])

  const classes = useStyles()
  const [value, setValue] = React.useState('1')
  const { id } = useParams()
  const [document, setDocument] = useState({})
  const [items, setItems] = useState(itemss)
  const [financeInformation, setFinanceInformation] = useState({})
  const [utilisationLabel, setUtilisationLabel] = useState('')
  const [files, setFiles] = useState(null)
  const [upload, setUpload] = useState(false)
  const [operations, setOperations] = useState({})
  const [operationsH, setOperationsH] = useState({})
  const [eventF, setEventF] = useState(false)
  const [eventViewF, setEventViewF] = useState(false)

  useEffect(() => {
    fetchDocumentDetail()
    fetchEntretienHistoriques()
    fetchOperations()
  }, [])

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }
  function AddContact({ vid, updateVehicle, setOpen }) {
    // const [open, setOpen] = useState(false)
    const [contacts, setContacts] = useState([])

    const roles = [
      { id: 1, label: 'Agent immobilier' },
      { id: 2, label: 'Gestion locative' },
      { id: 3, label: 'Vente de bien' },
      { id: 4, label: 'Recherche de nouveaux locataires' },
      { id: 5, label: 'Notaire' },
      { id: 6, label: 'Banque' },
      { id: 7, label: 'Autres établissements financier' },
      { id: 8, label: 'Assurances' },
      { id: 9, label: 'Travaux de rénovation' },
      { id: 10, label: 'Entretien et réparations' },
      { id: 11, label: 'Electriciens' },
      { id: 12, label: 'Plombiers' },
      { id: 13, label: 'Peintres' },
      { id: 14, label: 'Architecte' },
      { id: 15, label: 'Autres artisans' },
      { id: 16, label: 'Comptable' },
      { id: 17, label: 'Fiscaliste' },
      { id: 18, label: 'Gestionnaire de copropriété' },
      { id: 19, label: 'Avocat' },
      { id: 20, label: 'Eau' },
      { id: 21, label: 'Electricité' },
      { id: 22, label: 'Gaz' },
      { id: 23, label: 'Autorités locales' },
      { id: 24, label: 'Propriétaire' },
      { id: 25, label: 'Internet / TV / Téléphone' },
      { id: 26, label: 'Concierge' },
      { id: 27, label: 'Serruriers' },
      { id: 28, label: 'Mairie' },
      { id: 29, label: 'Voisins' },
      { id: 30, label: 'nettoyage' },
      { id: 31, label: 'Assistance juridique ' },
    ]

    const { handleSubmit, control, setValue, reset } = useForm({
      defaultValues: {
        contact: '',
        immobilier: vid,
        role: '',
      },
    })

    // const handleClickOpen = () => {
    //   setOpen(true)
    //   fetchContacts()
    // }
    useEffect(() => {
      fetchContacts()
    }, [])
    const fetchContacts = async () => {
      const filterContacts = []
      const { data } = await makeGetRequest('/api/Social/get-all-contacts/', {}, true)
      data.map((v) => {
        filterContacts.push({ label: v.Nom, id: v.id })
        return ''
      })
      setContacts([...filterContacts])
    }
    const handleClose = () => {
      setOpen(false)
      reset()
    }

    const onSubmit = async (data) => {
      const payload = {
        ...data,
        contact: data.contact.id,
        role: data.role.label,
      }

      const response = await makePostRequest(urls.addVContactOp, payload, {}, true)
      if (response.status === 201) {
        updateVehicle()
        handleClose()
      }
    }

    return (
      <>
        {/* <CustomButton onClick={handleClickOpen}>Ajouter</CustomButton> */}
        <Dialog fullWidth maxWidth="xs" open={true} onClose={handleClose}>
          <DialogTitle sx={{ color: 'black !important' }}>Affectation contact</DialogTitle>
          <form onSubmit={handleSubmit(onSubmit)}>
            <DialogContent>
              <ComboBox
                handleAutoComplete={(e, j) => {
                  setValue('contact', j)
                }}
                label="Sélectionner contact"
                data={contacts}
                name="contact"
              />
              <ComboBox
                handleAutoComplete={(e, j) => {
                  setValue('role', j)
                }}
                label="Rôles"
                data={roles}
                name="role"
              />
            </DialogContent>
            <DialogActions>
              <Button type="submit">Valider</Button>
              <Button onClick={handleClose}>Annuler</Button>
            </DialogActions>
          </form>
        </Dialog>
      </>
    )
  }

  const deleteImg = async (img_id) => {
    if (img_id > 0) {
      let response = await makeDeleteRequest(urls.immobilierImgDelte + img_id + '/', {}, true)
      if (response.status === 200) {
        const filteredItems = items.filter((v) => v.id !== img_id)
        if (filteredItems.length === 0) {
          setItems(itemss)
        } else {
          setItems([...filteredItems])
        }
      }
    }
  }
  const fetchOperations = async (pagination = '') => {
    // setLoading(true)
    let url = `${
      urls.crudEntretienRealiserOperations + `?vid=${id}&Done=false&page=immobilier&Schedule=Oui`
    }`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      // setLoading(false)
    }
    // setLoading(false)
  }
  const fetchEntretienHistoriques = async (pagination = '') => {
    // setLoading(true)
    let url = `${
      urls.crudEntretienRealiserOperations + `?vid=${id}&Done=false&page=immobilier&Schedule=Non`
    }`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperationsH({ ...response.data })
      // setLoading(false)
    }
    // setLoading(false)
  }
  const upload_immobilier_picture = () => {
    if (files) {
      const filearr = Array.from(files)
      filearr.forEach(async (f) => {
        let formData = new FormData()
        let url = '/api/domicile/upload-immobilier-picture/'
        if (f != null) formData.append('image', f)
        formData.append('id', id)
        const response = await makePostRequest(
          url,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
          true,
        )
        if (response.status === 200) {
          const filterItems = items.filter((v) => v.id !== null)
          setItems([...filterItems, response.data])
          handleClose()
        }
      })
    }
  }
  const fetchDocumentDetail = async () => {
    const response = await makeGetRequest(urls.crudImmobilier + id, {}, true)
    if (response.status === 200) {
      const {
        property_residence,
        professional_immobilier,
        property_location_immobilier,
        locatif_immobilier,
        pictures,
      } = response.data
      if (pictures.length > 0) setItems(pictures)
      setDocument({ ...response.data })
      if (property_location_immobilier !== null) {
        setFinanceInformation({ ...property_location_immobilier })
      } else if (property_residence !== null) {
        setFinanceInformation({ ...property_residence })
      } else if (professional_immobilier !== null) {
        setFinanceInformation({ ...professional_immobilier })
      } else {
        setFinanceInformation({ ...locatif_immobilier })
      }
      const finalUtilisationLabel = UTILISATION.find((v) => v.value === response.data.utilisation)
      setUtilisationLabel(finalUtilisationLabel.label)
    }
  }

  const displayColumn = (name, value, postfix = '', Icone = '') => (
    <Box>
      {name === 'Classe énergie1' ? (
        <Typography
          variant="h6"
          sx={{
            color:
              value === 'A'
                ? 'green'
                : value === 'B'
                ? 'lightgreen'
                : value === 'C'
                ? 'very light green'
                : value === 'D'
                ? 'yellow'
                : value === 'E'
                ? 'orange'
                : value === 'F'
                ? 'darkorange'
                : value === 'G'
                ? 'red'
                : 'unset',
          }}
        >
          {value}
        </Typography>
      ) : (
        <WTypography variant="h6">
          {value || 'N/A'} {postfix || ''}
        </WTypography>
      )}
      {Icone ? (
        <Typography color="secondary">
          {name} <Icone />
        </Typography>
      ) : (
        <Typography color="secondary">{name}</Typography>
      )}
    </Box>
  )

  function ImmoValueEditicone() {
    const historiquekm = () => {
      navigate(`/domicile/immovalue/immobilier/${id}`)
    }
    return (
      <>
        <EditIcon onClick={historiquekm} cursor={'pointer'} fontSize={'inherit'} color={'white'} />
      </>
    )
  }

  function FinancementEditicone() {
    const financement = () => {
      navigate(`/domicile/financement/immobilier/${id}`)
    }
    return (
      <>
        <EditIcon onClick={financement} cursor={'pointer'} fontSize={'inherit'} color={'white'} />
      </>
    )
  }
  function DetailDepenseEditicone() {
    const detaildepense = () => {
      navigate(`/domicile/detaildepense/immobilier/${id}`)
    }
    return (
      <>
        <EditIcon onClick={detaildepense} cursor={'pointer'} fontSize={'inherit'} color={'white'} />
      </>
    )
  }
  const informationGenerales = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <WTypography variant="h6">Informations générales</WTypography>
      <Box display={'flex'} flexWrap="wrap" justifyContent={'space-between'} px={4} py={1}>
        <Box>{displayColumn('Pays', document.payss?.Designation)}</Box>
        <Box>{displayColumn('Utilisation', utilisationLabel)}</Box>
        <Box>
          {displayColumn(
            'Date de création',
            convertToUserDateFormate(siteUser.user, document.created_at),
          )}
        </Box>
      </Box>
    </Box>
  )

  const techniqalCharacteristics = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <WTypography variant="h6">Caractéristiques techniques</WTypography>
      <Box display={'flex'} flexWrap="wrap" justifyContent={'space-between'} px={4} py={1}>
        <Box>
          {displayColumn('Pieces', document.pieces)}
          {displayColumn('Superficie', document.superficies?.answer)}
        </Box>
        <Box>
          {displayColumn('Classe énergie', document.energy_classifications?.answer)}
          {displayColumn(
            'Consommation énergétique',
            document.consumptions?.immoEmissionG,
            ' Kwh/an',
          )}
        </Box>
        <Box>
          {displayColumn('Type de bien', document.type_de_biens?.answer)}
          {displayColumn('Emission', document.emission_CO2, ' To CO²/an')}
        </Box>
      </Box>
    </Box>
  )

  const financialInformation = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <WTypography variant="h6">Information financières</WTypography>
      <Box display={'flex'} flexWrap="wrap" justifyContent={'space-between'} px={4} py={1}>
        {document?.utilisation &&
          (document.utilisation === 'Residence propriétaire' ||
            document.utilisation === 'Professionnel' ||
            document.utilisation === 'Locatif') && (
            <>
              <Box>
                {displayColumn('Valeur marché', financeInformation?.valeur, '', ImmoValueEditicone)}
                {displayColumn("Prix d'acquisition", financeInformation.purchase_price)}
                {displayColumn(
                  'Dépense/revenus',
                  document.depense_revenu,
                  '',
                  DetailDepenseEditicone,
                )}
              </Box>
              <Box>
                {displayColumn('Date d’acquisition', financeInformation.date_of_purchase)}
                {displayColumn('Date de valorisation', financeInformation.date_of_sale)}
              </Box>
              <Box>
                {document.utilisation === 'Locatif' && (
                  <>{displayColumn('Loyer', financeInformation.financement)}</>
                )}
                {displayColumn(
                  'Financement',
                  financeInformation.financement,
                  '',
                  FinancementEditicone,
                )}
              </Box>
            </>
          )}

        {document?.utilisation && document.utilisation === 'Location' && (
          <>
            <Box>
              {displayColumn(
                `Date d'entrée`,
                convertToUserDateFormate(siteUser.user, financeInformation.date_of_entry),
              )}
              {displayColumn('Loyer', financeInformation.loyer)}
            </Box>
            <Box>
              {displayColumn('Charges', financeInformation.charges)}
              {displayColumn(
                'Dépense/revenus',
                document.depense_revenu,
                '',
                DetailDepenseEditicone,
              )}
            </Box>
            <Box></Box>
          </>
        )}
        {/* {document?.utilisation && (document.utilisation === 'Residence propriétaire' ||
            document.utilisation === 'Location') && (
              <>
                <Box>
                  {displayColumn(`Nombre d'habitant`, financeInformation.nombre_habitants?.estimate_emisionT)}
                  {displayColumn(`Type de chauffe-eau`, financeInformation.type_chauffe_eaus?.estimate_emisionT)}
                </Box>
                <Box>
                  {displayColumn(`Norme`, financeInformation.normes?.estimate_emisionT)}
                  {displayColumn(`Type de chauffage`, financeInformation.type_de_chauffages?.estimate_emisionT)}
                </Box>
              </>
            )
        } */}
      </Box>
    </Box>
  )
  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const response = await makePostRequest(
        urls.deleteVehicleContacts,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        fetchDocumentDetail()
        setSelected([])
      }
    }
  }
  const contact = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <Box sx={{ display: 'flex', pb: 3 }}>
        <WTypography variant="h6">Contact</WTypography>
        <Box sx={{ marginLeft: 'auto' }}>
          <CustomButton onClick={() => setOpenAContactForm(true)}>Ajouter</CustomButton>
          <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
        </Box>
      </Box>

      <Box>
        {document?.contactsList?.map((row, index) => (
          <Box
            key={row.id}
            sx={{ display: 'flex', '.MuiCheckbox-root': { color: 'white !important' } }}
          >
            <Checkbox
              onClick={(event) => handleClick(event, row.id)}
              color="secondary"
              inputProps={{
                'aria-labelledby': index,
              }}
            />
            <Box
              className={classes.contactBox}
              onClick={() => navigate(`/MesContacts?cid=${row.contact}`)}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Avatar sx={{ marginRight: '10px' }} alt="" src={row.contactObj?.Picture} />
              <WTypography>
                {row.contactObj?.Titres?.Titre}. {row.contactObj?.Nom} --------- {row.role}
              </WTypography>
            </Box>
          </Box>
        ))}
        {document?.contactsList?.length === 0 && <Box sx={{ color: 'white' }}>No contact</Box>}
      </Box>

      {/* {document.utilisation === '2' ? (
        <WTypography>{financeInformation.bailleur} Bailleur</WTypography>
      ) : (
        <WTypography>{financeInformation.responsable} Responsable</WTypography>
      )} */}
    </Box>
  )

  const plandentretien = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      {operations.results?.length > 0 ? (
        <>
          <WTypography
            variant="h6"
            onClick={() =>
              navigate(`/domicile/entretien/${operations.results[0].IdMaintenanceplan}`)
            }
          >
            Plan d'entretien
          </WTypography>
        </>
      ) : (
        <>
          {operationsH.results?.length > 0 ? (
            <WTypography
              variant="h6"
              onClick={() =>
                navigate(`/domicile/entretien/${operationsH.results[0].IdMaintenanceplan}`)
              }
            >
              Plan d'entretien
            </WTypography>
          ) : (
            <WTypography variant="h6">Plan d'entretien</WTypography>
          )}
        </>
      )}
      <Box
        className="calendar-container"
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: isMobile ? 'column' : 'row',
          width: '100%',
        }}
      >
        <Box
          className="calendar-box"
          sx={{ width: isMobile ? '100%' : '50%', '#year': { minWidth: '0' } }}
        >
          <CalendarView id={id} page="immobilier" />
        </Box>
        <Box className="calendar-view" sx={{ width: isMobile ? '100%' : '50%' }}>
          <ListTop operations={operations} setEventViewF={setEventViewF} />
          <ListBottom operations={operationsH} setEventF={setEventF} />
        </Box>
      </Box>
      {/* <WTypography> Coming soon</WTypography> */}
    </Box>
  )
  const documents = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      {/* <WTypography variant="h6">Documents</WTypography> */}

      {/* <WTypography> Coming soon</WTypography> */}
      <BasicTable />
    </Box>
  )
  const handleClose = () => {
    setUpload(false)
    setFiles(null)
  }
  return (
    <>
      {openAContactForm && (
        <AddContact setOpen={setOpenAContactForm} updateVehicle={fetchDocumentDetail} vid={id} />
      )}
      {eventViewF && <EventViewForm setEventViewF={setEventViewF} row={eventViewF} />}
      {eventF && (
        <CreateEventForm
          setEventF={setEventF}
          fetchOperations={fetchOperations}
          fetchEntretienHistoriques={fetchEntretienHistoriques}
          row={eventF}
        />
      )}
      <Container maxWidth="lg">
        {/* DocumentDetails */}
        <Box
          sx={{
            position: 'relative',
            height: '330px',
          }}
        >
          <Carousel
            className="imgBoxCarousel"
            sx={{ height: '100%', img: { height: '330px' } }}
            duration={7}
            navButtonsAlwaysVisible
            fullHeightHover={false}
          >
            {items.map((item, i) => (
              <Fragment key={i}>
                {item.id ? (
                  <CloseIcon
                    className="imgclose"
                    onClick={() => deleteImg(item.id)}
                    sx={{
                      position: 'absolute',
                      right: '13px',
                      color: 'white',
                      zIndex: 5,
                      backgroundColor: '#4c4c4c',
                      padding: '3px',
                      fontSize: '30px',
                      borderRadius: '14px',
                      bottom: '45px',
                    }}
                  />
                ) : (
                  ''
                )}
                <img src={item['picture']} alt="img" width={'100%'} height="400px" />
              </Fragment>
            ))}
          </Carousel>
          {items.length < 5 ? (
            <FileUploadIcon
              onClick={() => setUpload(true)}
              sx={{
                position: 'absolute',
                right: '13px',
                color: 'white',
                zIndex: 5,
                backgroundColor: '#4c4c4c',
                padding: '3px',
                fontSize: '30px',
                borderRadius: '14px',
                bottom: '5px',
              }}
            />
          ) : (
            ''
          )}
        </Box>
        <WTypography variant="h4">{document.nom}</WTypography>

        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                '.MuiTabs-flexContainer': {
                  overflow: 'auto',
                },
              }}
            >
              <TabList onChange={handleChange}>
                <Tab sx={{ color: 'white' }} label="Informations générales" value="1" />
                <Tab sx={{ color: 'white' }} label="Caractéristiques techniques" value="2" />
                <Tab sx={{ color: 'white' }} label="Informations financières" value="3" />
                <Tab sx={{ color: 'white' }} label="Contact" value="4" />
                <Tab sx={{ color: 'white' }} label="Document" value="5" />
                <Tab sx={{ color: 'white' }} label="Planning entretien" value="6" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <WTypography variant="h6">{informationGenerales}</WTypography>
            </TabPanel>
            <TabPanel value="2">{techniqalCharacteristics}</TabPanel>
            <TabPanel value="3">{financialInformation}</TabPanel>
            <TabPanel value="4">{contact}</TabPanel>
            <TabPanel value="5">{documents}</TabPanel>
            <TabPanel value="6" sx={{ p: isMobile ? 0 : 3 }}>
              {plandentretien}
            </TabPanel>
          </TabContext>
        </Box>

        {/* 
      {informationGenerales}
      {techniqalCharacteristics}
      {financialInformation}
      {contact}
      {documents} */}

        <Dialog
          open={upload}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle sx={{ backgroundColor: '#202020' }}>Upload Immobilier Images</DialogTitle>

          <ImmobilierImgUploadForm
            handleClose={handleClose}
            setFiles={setFiles}
            files={files}
            upload_immobilier_picture={upload_immobilier_picture}
          />
        </Dialog>
      </Container>
    </>
  )
}
function BasicTable() {
  const siteUser = useSelector((store) => store.user)

  let params = useParams()
  const [selected, setSelected] = React.useState([])
  const [rowsPerPage, setRowsPerPage] = React.useState(20)
  const [newRows, setNewRows] = useState([])

  useEffect(() => {
    fetchOperations(params.id, 20)
  }, [])
  const fetchOperations = async (id, limit) => {
    const { data, status } = await makeGetRequest(
      `/api/Administrative/Documents/Immobilier/${id}/?limit=${limit}`,
      {},
      true,
    )
    if (status === 200) {
      let results = data.results
      setNewRows([...results])
    }
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(rowsPerPage + 20)
    fetchOperations(params.id, rowsPerPage + 20)
  }
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }
  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const response = await makePostRequest(
        urls.deleteDocumentsBulkOperations,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        fetchOperations(params.id, 20)
        setSelected([])
      }
    }
  }

  return (
    <>
      <Box>
        <Typography variant="h5" pl={3} pt={3} sx={{ color: 'white' }}>
          Related documents
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }} py={5}>
        <Box>
          <Typography variant="h5" pl={3} sx={{ color: 'white' }}>
            Documents ({newRows.length})
          </Typography>
        </Box>
        <Box>
          <CreateDocumentsForm params={params} account="Immobilier" setNewRows={setNewRows} />
          <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
        </Box>
      </Box>
      <Box sx={{ color: 'white', paddingBottom: '60px' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650, marginTop: '23px' }} size="small" aria-label="simple table">
            <TableBody>
              {newRows && newRows.length > 0 ? (
                newRows.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{ height: '80px', '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Checkbox
                        onClick={(event) => handleClick(event, row.id)}
                        color="primary"
                        inputProps={{
                          'aria-labelledby': index,
                        }}
                      />
                      {/* {row.Lien.split('/').pop()} */}
                      <AttachmentIcon sx={{ padding: '0px 13px', fontSize: '45px' }} />
                      <div>
                        <Link sx={{ fontSize: '16px' }} href={row.Lien}>
                          {row.Lien.split('/').pop()}
                        </Link>
                        <br />
                        Charge le: {convertToUserDateFormate(siteUser.user, row.Datedimport)} -
                        Taille de fichier: {row.FileSize} Mio
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3}>No data yet.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {/* {newRows.length > 20 && newRows.results.length % 20 === 0 ? ( */}
          {newRows.length > 20 ? (
            <Box display={'flex'} justifyContent={'center'}>
              <Button onClick={handleChangeRowsPerPage}>Load More</Button>
            </Box>
          ) : (
            newRows.length > 20 && (
              <Box display={'flex'} justifyContent={'center'}>
                <Button
                  onClick={() => {
                    fetchOperations(params.id, 20)
                    setRowsPerPage(20)
                  }}
                >
                  Return to initial Size
                </Button>
              </Box>
            )
          )}
        </TableContainer>
      </Box>
    </>
  )
}
